export const en = {
  'bank.mode': 'Calculation method',
  'bank.monthly': 'Standard — APR / 12 each month',
  'bank.calendar': 'Bank schedule — actual calendar days',
  'bank.explanation': 'Interest for actual days at 365/366 days per year. An annuity payment is never below the interest for a 31-day month; the first one also covers the first period.',
  'bank.disbursement': 'Disbursement / previous payment date',
  'bank.paymentDay': 'Scheduled payment day',
  'bank.recalculate': 'Scheduled payment recalculations',
  'bank.recalculateHint': 'If the bank recalculates the payment on schedule, enter the month of the first payment with the new amount. It is based on the current balance, the same APR and the remaining term. Empty means no recalculation.',
  'bank.recalculateMonth': 'Month of the new payment',
  'bank.recalculateAdd': '+ Add recalculation',
  'bank.recalculateRemove': 'Remove recalculation',
  'bank.overpaymentHint': 'Overpayments apply on the due date after the scheduled payment. Payment reduction starts next month; term reduction retains the current payment. Payments between due dates are not modelled.',
  'bank.modeError': 'Select a calculation method.',
  'bank.error': 'Calendar mode requires a disbursement date before the first payment, a payment day between 1 and 31 and recalculation months after the first payment within the loan term.',
  'bank.log': 'Calendar calculation: due day {day}; overpayments after the scheduled payment on the same day.',
  'summary.totalInterest': 'Total interest',
  'summary.totalPaid': 'Total paid',
  'summary.actualTerm': 'Actual term',
  'summary.maxMonthlyPayment': 'Max monthly payment',
  'summary.payoffDate': 'Payoff date',
  'actions.save': 'Save',
  'actions.share': 'Share scenario',
};

